import { useSelector } from "react-redux";

const useCurrentUser = () => {
  return useSelector(({ hubly }) => {
    return hubly?.data?.advisor;
  });
};

export default useCurrentUser;
